import { Button } from '@components';
import React from 'react';

export const FaleConoscoCard = () => {
  return (
    <div className="card">
      <div className="card-body">
        <h1 className="ts-20 fw-bold mb-2">Fale conosco</h1>
        <p className="ts-14 text-muted mb-32">
          Estamos aqui para ajudar! Clique no botão abaixo para acessar nossa
          Central de Atendimento e resolver suas dúvidas.
        </p>

        <Button
          onClick={() =>
            window.open(
              'https://forluz.neoassist.com/?th=tag_vforluzfixa&openEmail=true&mainCategory',
              '_blank'
            )
          }
        >
          Central de Atendimentos
        </Button>
      </div>
    </div>
  );
};
